import { render, staticRenderFns } from "./TPV.vue?vue&type=template&id=3cd66df4"
import script from "./TPV.vue?vue&type=script&lang=js"
export * from "./TPV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports